import { Appointment, SaveAppointment } from 'types/Appointment';
import { SaveOrder } from 'types/Order';

export interface PendingForms {
    hasPending: boolean;
    token?: string;
}

export interface Booking {
    id: number;
    uuid: string;
    marketplaceId: number;

    staffId?: number;
    customerId: number;

    appointments: Array<Appointment>;
    pendingForms?: PendingForms;
}

export type SaveBooking = Omit<Booking, 'id' | 'appointments'> & {
    addressId?: number;
    order?: SaveOrder;
    appointments: Array<SaveAppointment>;
};

export enum BookingChannel {
    ONLINE_BOOKING = 'online-booking'
}

export enum BookingStatus {
    REQUESTED = 0,
    CONFIRMED = 1,
    PENDING = 11
}
